function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "gitter_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB0766",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C50948",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h256v256H0V0z",
  fill: "url(#gitter_svg__a)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M83.914 62.873h12.525v82.661H83.914V62.873zm76.149 20.039h12.524v62.622h-12.524V82.912zm-50.599 0h12.524v110.466h-12.524V82.912zm25.049 0h12.525v110.466h-12.525V82.912z",
  fill: "#FFF"
});

var SvgGitter = function SvgGitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 256 256",
    preserveAspectRatio: "xMidYMid"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUwMCIgaGVpZ2h0PSIyNTAwIiB2aWV3Qm94PSIwIDAgMjU2IDI1NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIwJSIgeDI9IjUwJSIgeTI9IjEwMCUiIGlkPSJhIj48c3RvcCBzdG9wLWNvbG9yPSIjRkIwNzY2IiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iI0M1MDk0OCIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHBhdGggZD0iTTAgMGgyNTZ2MjU2SDBWMHoiIGZpbGw9InVybCgjYSkiLz48cGF0aCBkPSJNODMuOTE0IDYyLjg3M2gxMi41MjV2ODIuNjYxSDgzLjkxNFY2Mi44NzN6bTc2LjE0OSAyMC4wMzloMTIuNTI0djYyLjYyMmgtMTIuNTI0VjgyLjkxMnptLTUwLjU5OSAwaDEyLjUyNHYxMTAuNDY2aC0xMi41MjRWODIuOTEyem0yNS4wNDkgMGgxMi41MjV2MTEwLjQ2NmgtMTIuNTI1VjgyLjkxMnoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=";
export { SvgGitter as ReactComponent };